import React, { useState, useEffect } from "react";
import Select from "react-select";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { toast } from "react-toastify";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import { symbol } from "prop-types";

function CurrencySettings() {
  const { fetchRequest } = useMyContext()
  const baseURL = process.env.REACT_APP_Baseurl

  const currencyApi = `${baseURL}/admin/currency_setting/index`
  const updateApi = `${baseURL}/admin/currency_setting/store`

  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
    currencyOption: []
  })
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [formData, setFormData] = useState({
    state: "formData",
  })
  const [loading, setLoading] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);

  const formatOptionLabel = (item) => {
    return `${item?.name} -  ${item?.code} -  (${item?.symbol}) `;
  };


  const handleInput = async (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'text' || type === 'select-one') {
      const selectedCountry = defaultOption?.currencyOption?.find(item => item.country === value);

      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ...(selectedCountry && { symbol: selectedCountry.symbol }),
      }));
    }
    if (type === "checkbox") {
      setFormData((prev) => {
        // Ensure "same_country_toggle", "enable_multi_currency", and "enable_secondary_currency" are mutually exclusive
        const isModeToggle = ["same_country_toggle", "enable_multi_currency", "enable_secondary_currency"].includes(name);
        
        if (isModeToggle && !checked) {
          // If trying to turn off, check if others are also off
          const others = ["same_country_toggle", "enable_multi_currency", "enable_secondary_currency"].filter(k => k !== name);
          const anyOtherOn = others.some(k => prev[k] == 1);
          if (!anyOtherOn) {
            // Prevent turning off the last active toggle
            return prev;
          }
        }

        const newData = {
          ...prev,
          [name]: checked ? 1 : 0,
        };

        if (checked && isModeToggle) {
          if (name === "same_country_toggle") {
            newData.enable_multi_currency = 0;
            newData.enable_secondary_currency = 0;
          } else if (name === "enable_multi_currency") {
            newData.same_country_toggle = 0;
            newData.enable_secondary_currency = 0;
          } else if (name === "enable_secondary_currency") {
            newData.same_country_toggle = 0;
            newData.enable_multi_currency = 0;
          }
        }

        return newData;
      });
    }
  };

  const handleMultiSelect = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      secondary_currencies: selectedOptions
    }));
  };

  const handleStore = async () => {
    setLoading(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (["country", "enable_multi_currency", "same_country_toggle", "enable_secondary_currency", "secondary_currencies"].includes(key)) {
          if (key === 'secondary_currencies' && Array.isArray(formData[key])) {
            formDataAdd[key] = formData[key].map(item => item.value);
          } else {
            formDataAdd[key] = formData[key]
          }
        }
      }
      const response = await fetchRequest({
        method: 'POST',
        url: `${updateApi}`,
        params: {},
        data: formDataAdd,
      })
      const result = response;
      if (result?.status) {
        toast.success(result?.message)
        setWithOutRefresh(!withOutRefresh)
      }
    }
    catch (err) {
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(async () => {
    setShowOverlay(true)
    const response = await fetchRequest({
      method: 'GET',
      url: `${currencyApi}`,
      params: {},
      data: {},
    })
      .then((response) => {
        setDefaultOption((prev) => ({
          ...prev,
          currencyOption: response?.allCurrency,
        }))
        setFormData((prev) => ({
          ...prev,
          ...response?.CurrencySetting,
          secondary_currencies: response?.CurrencySetting?.secondary_currencies
            ? JSON.parse(response?.CurrencySetting?.secondary_currencies).map(code => {
              const currency = response?.allCurrency?.find(c => c.code === code);
              return { label: currency ? `${currency.country} (${currency.code})` : code, value: code };
            })
            : []
        }))
      })
      .finally(() => {
        setShowOverlay(false)
      })

  }, [withOutRefresh])

  if (showOverlay) {
    return <Defaultloadinggif className={`heightOnLoader`} />
  }
  return (
    <>
      <AdminSaveHeader heading={"Currency Setting"} saveText={"Update"} loading={loading} saveMethod={handleStore} />
      <FormContainer>
        <LeftWrapper className="">
          <Wrapper className="position-relative">
            <MessageHeading text="Primary Currency" />

            <div className="d-flex justify-content-between mb-2">
              <div className="col-6 col-md-6 pe-2"><MessageLabel text={"Enable Primary Country"} /></div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'same_country_toggle'} checked={formData?.same_country_toggle == 1} onChange={handleInput} />
              </div>
            </div>

            <MessageLabel text="Global Currency Country" />
            <AdminCustomSelect name="country" value={formData?.country} onChange={handleInput} options={defaultOption?.currencyOption?.map((item, index) => ({ name: item?.country, value: item?.country, symbol: item?.symbol, code: item?.code }))} formatOptionLabel={(item) => formatOptionLabel(item)} />
            <div className="position-absolute  currency-settings-flag d-flex align-items-center gap-3 py-1 px-3 rounded-2 theme-bg-color shadow-lg ">
              <MessageBox text={formData?.country} classname="" />
              <button type="button" className="theme-border-secondary shadow-lg pop-up-admin-heading theme-button-color">
                <MessageBox text={formData?.symbol} classname="" />
              </button>
            </div>
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text="Multi Currency Setting" />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Geo-Based Multi-Currency"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'enable_multi_currency'} checked={formData?.enable_multi_currency == 1} onChange={handleInput} />
              </div>
            </div>

            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Secondary Countries"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'enable_secondary_currency'} checked={formData?.enable_secondary_currency == 1} onChange={handleInput} />
              </div>
            </div>

            {formData?.enable_secondary_currency == 1 && (
              <>
                <MessageHeading text="Select Secondary Currencies" />
                <div className="text-dark mb-4">
                  <Select
                    options={defaultOption?.currencyOption?.map(item => ({ label: `${item.country} (${item.code})`, value: item.code }))}
                    isMulti
                    name="secondary_currencies"
                    onChange={handleMultiSelect}
                    value={formData?.secondary_currencies}
                    className="custom-select-multi custom-placeholder theme-text-color mb-3"
                    placeholder="Select Secondary Currencies"
                  />
                </div>
              </>
            )}
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}
export default CurrencySettings;